<template src="./html/FilterBar.html"></template>

<script>
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth', 'statuses', 'customer', 'project'],
		data () {
			return {
				projects: null,
				users: null,

				filter: {
					allowDate: false,
					date: null,
					text: null,
					assigned_to: null,
					budget_status_id: null,
					customer_id: null,
					project_id: null,
				}
			}
		},
		watch: {
			'filter.allowDate'() {
				this.initDate()
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				if(this.customer) {
					this.filter.customer_id = this.customer.id
				}
				if(this.project) {
					this.filter.project_id = this.project.id
				}
			},
			collapse() {
				$(this.$refs.filter).collapse("toggle")
			},
			keyUpdoFilter(event) {
				if(this.filter.text) {
					if(event.code == 13) {
						this.doFilter()
					} else {
						if(event.code != 32) {
							this.doFilter()
						}
					}
				} else {
					this.doFilter()
				}
			},
			doFilter() {
				if(this.filter.text) {
					this.filter.text = this.filter.text.trimStart()
				}
				if(!this.filter.allowDate) {
					this.filter.date = null
				}
				this.$events.fire('filterSet', this.filter)
			},
			clearData() {
				this.filter.text = null
				this.filter.allowDate = false
				this.filter.date = null
				this.filter.assigned_to = null
				this.filter.budget_status_id = null
			},
			reset() {
				this.clearData()
				this.$events.fire('filterReset', this.filter)
			},
			filterUser() {
				if(this.filter.assigned_to) {
					this.filter.assigned_to = null
				} else {
					this.filter.assigned_to = this.user.id
				}
				this.doFilter()
			},
			filterStatus(status) {
				this.filter.budget_status_id = status.id
				this.doFilter()
			},
			initDate() {
				var that = this
				var year = moment().format('YY')
				var month = moment().format('MM')
				var startDate = moment([year, month - 1])
				var endDate = moment()
				$('.daterange').daterangepicker({
					"startDate": startDate.format('DD/MM/YY'),
					"endDate": endDate.format('DD/MM/YY'),
					"locale": {
						"format": "DD/MM/YY",
						"separator": " - ",
						"applyLabel": "Aceptar",
						"cancelLabel": "Cancelar",
						"fromLabel": "From",
						"toLabel": "To",
						"customRangeLabel": "Custom",
						"daysOfWeek": [
							"Do",
							"Lu",
							"Ma",
							"Mi",
							"Ju",
							"Vi",
							"Sa",
						],
						"monthNames": [
							"Enero",
							"Febrero",
							"Marzo",
							"Abril",
							"Mayo",
							"Junio",
							"Julio",
							"Agosto",
							"Septiembre",
							"Octubre",
							"Noviembre",
							"Diciembre",
						],
						"firstDay": 1
					}
				}).on('hide.daterangepicker', function(e, picker) {
					that.filter.date = moment(picker.startDate).format('DD/MM/YY') + ' - ' +moment(picker.endDate).format('DD/MM/YY')
				})
				this.filter.date = startDate.format('DD/MM/YY') + ' - ' + endDate.format('DD/MM/YY')
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/management/budgets/views/FilterBar.vue